import { apiClient } from 'client/core/network/apiClient';
import { LdapAuthDto } from 'common/dto/query/LdapAuthDto';

export const LdapAuthApi = {
  /** Creazione dell'access token per il login tramite credenziali LDAP */
  createAccessToken: (data: LdapAuthDto) =>
    apiClient.request().post('/auth/ldap/sso', data)
};
